import React from "react";
import { Link } from "react-router-dom"; // Using Link for proper navigation
import styles from "./Header.module.css";
import TextPressure from "./TextPressure";
import ThemeToggle from "./ThemeToggle";
import SoundToggle from "./SoundToggle";
import { useTheme } from "../context/ThemeContext";
import { useSound } from "../context/SoundContext";

const Header = ({ navigateTo, activeView }) => {
  const { darkMode } = useTheme();
  const { playClick } = useSound();
  const logoTextColor = darkMode ? "#f0f0f0" : "#555";

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <button
          className={styles.logoButton}
          onClick={() => {
            playClick();
            navigateTo("home");
          }}
        >
          <TextPressure
            text="kado."
            flex={false}
            alpha={false}
            stroke={false}
            width={false}
            weight={true}
            italic={false}
            textColor={logoTextColor}
            minFontSize={17.6}
            widthContainer={false}
          />
        </button>
      </div>
      <div className={styles.right}>
        <nav className={styles.nav}>
          <SoundToggle />
          <ThemeToggle />
          <button
            className={activeView === "about" ? styles.active : ""}
            onClick={() => {
              playClick();
              navigateTo("about");
            }}
          >
            about
          </button>
          <button
            className={activeView === "blog" ? styles.active : ""}
            onClick={() => {
              playClick();
              navigateTo("blog");
            }}
          >
            blog
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
